module.exports = __webpack_public_path__ + "img/icon-salir.6d0c9c61.svg";